import React from 'react';
import QuoteSteps from 'pu-react/components/QuoteSteps';
import { START, QUOTED, PRICE_SELECTED, ERROR } from 'pu-data/QuoteSteps';

const Steps = ({ quoteStep, parametersChanged }) => {
  let activeItem = 1;

  if (quoteStep === START || quoteStep === ERROR || parametersChanged) {
    activeItem = 1;
  } else if (quoteStep === QUOTED) {
    activeItem = 2;
  } else if (quoteStep === PRICE_SELECTED) {
    activeItem = 3;
  }

  return (
    <QuoteSteps activeItem={activeItem} />
  );
};

export default Steps;
